<template>
  <bg-tooltip
    variant="dark"
    trigger="hover"
    placement="bottom"
    :closable="false"
  >
    <bg-text size="title-5" class="bg-u-text-neutral-800">{{ label }}</bg-text>

    <template #tooltip-content>
      <ol v-if="isFillData" class="cta-header-tooltip__fields">
        <li v-for="(title, index) in cta.fieldTitles" :key="index">
          {{ title }}
        </li>
      </ol>

      <span v-else>{{ cta.label }}</span>
    </template>
  </bg-tooltip>
</template>

<script>
import { computed } from '@vue/composition-api';
import { BgText, BgTooltip } from 'bangul-vue';

export default {
  name: 'CtaHeaderTooltip',

  components: {
    BgText,
    BgTooltip,
  },

  props: {
    // The column header text (e.g. "Tombol A" / "Isian Data").
    label: {
      type: String,
      required: true,
    },
    // The matching CTA config: { action, label, fieldTitles }.
    cta: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const isFillData = computed(() => props.cta.action === 'fill_data');

    return {
      isFillData,
    };
  },
};
</script>

<style lang="scss" scoped>
.cta-header-tooltip__fields {
  padding-left: 20px;
  margin: 0;
  list-style: decimal;
}
</style>
